import React, { useState } from 'react';
import {
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Box
} from '@mui/material';
import axios from 'utils/axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthService from 'services/AuthService';
import { toast } from 'react-toastify';


const PasswordChange = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();

  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmedPassword, setConfirmedPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!password) newErrors.password = t('required_field');
    if (!newPassword) {
      newErrors.newPassword = t('required_password');
    } else {
      if (newPassword.length < 8) {
        newErrors.newPassword = t('password_length_min_6');
      } else if (newPassword.length > 32) {
        newErrors.newPassword = t('password_length_max_32');
      }
    }

    if (newPassword !== confirmedPassword) {
      newErrors.confirmedPassword = t('passwords_must_match') || 'Passwords do not match';
    }

    if (!confirmedPassword) {
      newErrors.confirmedPassword = t('required_password');
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
        const username = AuthService.getUsername()
      await axios.put('users/'+username+'/reset-password', {
        ...params,
        password,
        newPassword
      });
      toast.success(t('password_changed'));

      navigate('/dashboard');
    } catch (err) {
        toast.error('Promjena lozinke nije uspjela. Provjerite unesene podatke.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        {t('password_change')}
      </Typography>
      <Card>
        <CardContent>
          <form onSubmit={handleSubmit} noValidate>
            <TextField
              fullWidth
              margin="normal"
              label={t('current_password')}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={!!errors.password}
              helperText={errors.password}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label={t('new_password')}
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              error={!!errors.newPassword}
              helperText={errors.newPassword}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label={t('confirmed_password')}
              type="password"
              value={confirmedPassword}
              onChange={(e) => setConfirmedPassword(e.target.value)}
              error={!!errors.confirmedPassword}
              helperText={errors.confirmedPassword}
              required
            />

            <Box display="flex" justifyContent="flex-end" mt={2}>
              <Button variant="outlined" onClick={() => navigate(-1)} style={{ marginRight: 10 }}>
                {t('cancel')}
              </Button>
              <Button color="primary" variant="contained" type="submit" disabled={loading}>
                {t('save')}
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PasswordChange;
